import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import MembersList from './MembersList';
import { emptyConnection } from '../../../utils/UrlUtil';
import { withAccount } from '../../../components/AccountContext';

export const ASSESSMENTS_QUERY = gql`
  query(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: AssessmentFilter
    $sort: AssessmentSortSpecifier
  ) {
    account(id: $accountId) {
      id
      assessments(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        totalCount
        indexFrom
        indexTo
        edges {
          node {
            id
            locale
            status
            createdOn
            updatedOn
            respondent {
              id
              firstName
              lastName
              targetJob {
                id
                name
              }
            }
            template {
              id
              title
            }
          }
        }
      }
    }
  }
`;

class MembersListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      tempQuery: '',
      sort: undefined,
      search: {
        pageSize: 25,
        last: undefined,
        before: undefined,
        first: 25,
        after: undefined,
      },
    };
    this.isAllChecked = this.isAllChecked.bind(this);
    this.addAllTeams = this.addAllTeams.bind(this);
    this.onQueryChange = this.onQueryChange.bind(this);
    this.onTempChange = this.onTempChange.bind(this);
    this.changePageSize = this.changePageSize.bind(this);
    this.movePrev = this.movePrev.bind(this);
    this.moveNext = this.moveNext.bind(this);
  }

  onQueryChange(query) {
    this.setState({ query });
  }

  onTempChange(tempQuery) {
    this.setState({ tempQuery });
  }

  isAllChecked() {
    const { isAllChecked, data } = this.props;
    const { responseData } = data;
    return isAllChecked(responseData);
  }

  addAllTeams(event) {
    const isChecked = event.target.checked;
    const { addAllTeams, data } = this.props;
    const { responseData } = data;
    addAllTeams(isChecked, responseData);
  }

  changePageSize(event) {
    const { search: oldSearch } = this.state;
    const search = {
      ...oldSearch,
      pageSize: event.value,
      first: event.value,
      after: undefined,
      before: undefined,
      last: undefined,
    };

    this.setState({ search });
  }

  movePrev(startCursor) {
    const { search: oldSearch } = this.state;
    const search = {
      ...oldSearch,
      last: oldSearch.pageSize,
      before: startCursor,
      first: undefined,
      after: undefined,
    };

    this.setState({ search });
  }

  moveNext(endCursor) {
    const { search: oldSearch } = this.state;
    const search = {
      ...oldSearch,
      first: oldSearch.pageSize,
      after: endCursor,
      before: undefined,
      last: undefined,
    };

    this.setState({ search });
  }

  render() {
    const {
      currentAccount,
      translatedTags,
      selectSpecTeam,
      selectedTeams,
      addAllTeams,
      isAllChecked,
      templateId,
    } = this.props;
    const {
      query, tempQuery, search,
      sort,
    } = this.state;

    const variables = {
      ...search,
      accountId: currentAccount,
      sort,
      filter: {
        query,
        assessmentTemplateId: templateId,
      },
    };
    return (
      <Query query={ASSESSMENTS_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account ? data.account.assessments : emptyConnection();
          return (
            <Fragment>
              <MembersList
                connection={connection}
                currentAccount={currentAccount}
                translatedTags={translatedTags}
                loading={loading}
                selectSpecTeam={selectSpecTeam}
                selectedTeams={selectedTeams}
                isAllChecked={isAllChecked}
                addAllTeams={addAllTeams}
                onQueryChange={this.onQueryChange}
                onTempChange={this.onTempChange}
                query={tempQuery}
                search={search}
                changePageSize={this.changePageSize}
                movePrev={this.movePrev}
                moveNext={this.moveNext}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

MembersListContainer.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedTeams: PropTypes.arrayOf(PropTypes.any),
  currentAccount: PropTypes.string.isRequired,
  templateId: PropTypes.string.isRequired,
  selectSpecTeam: PropTypes.func.isRequired,
  addAllTeams: PropTypes.func.isRequired,
  isAllChecked: PropTypes.func.isRequired,
};

MembersListContainer.defaultProps = {
  selectedTeams: [],
  data: {},
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(injectIntl(connect(mapState)(withAccount(MembersListContainer))));
